import { measures } from 'styles/variables'

import { AVAILABLE_PROPS, SIDES, MQ_MAPPINGS } from './constants'

const { unit } = measures

export const applyMargin = (props) => {
  const result = []

  for (const sideKey of AVAILABLE_PROPS) {
    const scale = props[sideKey]

    if (scale == null) continue

    for (const side of SIDES[sideKey]) {
      result.push(`margin-${side}: ${scale * unit}px;`)
    }
  }

  return result.join('')
}

export const applyWhenHelper = ({ resetWhen }) => {
  const mediaQuery = MQ_MAPPINGS[resetWhen]
  return Boolean(mediaQuery) && `${mediaQuery} { margin: 0 !important; }`
}
